<div class="position-relative">
  <textarea
    class="input-base"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
      'pe-4': showClearButton(),
    }"
    [class.input-error]="error()"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    [rows]="rows()"
    (input)="handleInput($event)">
  </textarea>
  @if (showClearButton()) {
    <mat-icon
      class="input-trailing-icon"
      (click)="clearClicked()"
      [class]="{
        'input-trailing-icon-large': inputSize() === InputSize.large,
        'input-trailing-icon-small': inputSize() === InputSize.small,
      }"
      [svgIcon]="'close'">
    </mat-icon>
  }
</div>
